const CLIENTS_KEY = 'an_selected_clients';
const SAMPLE_FIELDS_KEY = 'an_sample_fields';
const USER_KEY = 'an_selected_user';

const JOB_SORT_KEY = 'an_job_sort';
const SAMPLE_SORT_KEY = 'an_sample_sort';
const RESULT_SORT_KEY = 'an_result_sort';

import CryptoJS from "crypto-js";

const SECRET_KEY = 'AnetengyumhajEnlamis';

// helper functions

const encrypt = item => CryptoJS.AES.encrypt(JSON.stringify(item), SECRET_KEY);
const decrypt = item => JSON.parse(CryptoJS.AES.decrypt(item, SECRET_KEY).toString(CryptoJS.enc.Utf8));
 
const getStorageItem = (key) => {
  const config = localStorage.getItem(key);
  if (!config) return null;
  try {
    return JSON.parse(decrypt(config));
  } catch(e) {
    return null;
  }
};

const setStorageItem = (key, value) => {
  localStorage.setItem(key, encrypt(JSON.stringify(value)));
};

const clearStorageItem = (key) => {
  if (localStorage.getItem(key)) localStorage.removeItem(key);
};

// exported functions

/** --------------------------------------------------
 * 
 *           users selected clients
 *
 * --------------------------------------------------- */
const storeClients = (clients) => {
  setStorageItem(CLIENTS_KEY, clients);
};

const getClients = () => {
  return getStorageItem(CLIENTS_KEY);
};

const clearClients = () => {
  clearStorageItem(CLIENTS_KEY);
};

/** --------------------------------------------------
 * 
 *           current user
 *
 * --------------------------------------------------- */
const storeUser = (user) => {
  setStorageItem(USER_KEY, user);
};

const getUser = () => {
  return getStorageItem(USER_KEY);
};

const clearUser = () => {
  clearStorageItem(USER_KEY);
};

/** --------------------------------------------------
 * 
 *           sample fields selection
 *
 * --------------------------------------------------- */
const storeSampleFields = (sampleFields) => {
  setStorageItem(SAMPLE_FIELDS_KEY, sampleFields);
};

const getSampleFields = () => {
  return getStorageItem(SAMPLE_FIELDS_KEY);
};

const clearSampleFields = () => {
  clearStorageItem(SAMPLE_FIELDS_KEY);
};

/** --------------------------------------------------
 * 
 *    Store, clear and retrieve the users table sorts
 *  
 * --------------------------------------------------- */

const storeJobSort = (config) => {
  setStorageItem(JOB_SORT_KEY, config);
};

const storeSampleSort = (config) => {
  setStorageItem(SAMPLE_SORT_KEY, config);
};

const storeResultSort = (config) => {
  setStorageItem(RESULT_SORT_KEY, config);
};

const getJobSort = () => {
  return getStorageItem(JOB_SORT_KEY);
};

const getSampleSort = () => {
  return getStorageItem(SAMPLE_SORT_KEY);
};

const getResultSort = () => {
  return getStorageItem(RESULT_SORT_KEY);
};

const clearJobSort = () => {
  clearStorageItem(JOB_SORT_KEY);
};

const clearSampleSort = () => {
  clearStorageItem(SAMPLE_SORT_KEY);
};

const clearResultSort = () => {
  clearStorageItem(RESULT_SORT_KEY);
};


export {
  storeClients,
  getClients,
  clearClients,

  storeUser,
  getUser,
  clearUser,

  storeSampleFields,
  getSampleFields,
  clearSampleFields,

  storeJobSort,
  getJobSort,
  clearJobSort,

  storeSampleSort,
  getSampleSort,
  clearSampleSort,

  storeResultSort,
  getResultSort,
  clearResultSort
};


// WEBPACK FOOTER //
// ./src/services/localstorage.js